export const FILE_URL = "https://api-digital-tex.tsul.uz/";